import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button } from "@mui/material";
import { ArrowBack } from "assests/images";
import { ConciergeForm } from "components";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AppRoutings } from "utility/enums/app-routings";
import { IConciergeDetails, IValidationParms } from "utility/interfaces";
import { conciergeFormSchema } from "utility/validations";

const ConciergeRequest: React.FC = () => {
  // Page level variables
  const navigate = useNavigate();

  // state variables
  const [conciergeDetails, setConciergeDetails] = useState<IConciergeDetails>({
    conciergeEmail: "",
    conciergeFirstName: "",
    conciergeLastName: "",
    conciergePhoneNumber: "",
    isRequestorSMSOpted: false,
    hotelPropertyName: "",
    radioRequestorPhoneType: "M",
    patientDetails: {
      symptoms: "",
      firstName: "",
      lastName: "",
      birthDate: "",
      email: "",
      phoneNumber: "",
      isPatientSMSOpted: false,
      radioClientPhoneType: "M",
      street: "",
      city: "",
      state: "",
      zipCode: "",
      room: "",
      document: "",
      documentName: "",
      clientRegionId: 0,
    },
  });

  // handle events and function
  const handleOnBackButtonClick = () => {
    navigate(AppRoutings.CreateRequest);
  };

  const onChangeConciergeDetails = (name: string, value: any) => {
    setConciergeDetails({ ...conciergeDetails, [name]: value });
  };

  // Yup resolver and validation
  const {
    register: conciergeFormRegister,
    handleSubmit: conciergeFormHandleSubmit,
    formState: { errors: conciergeFormErrors },
    reset: conciergeFormReset,
    clearErrors: conciergeFormClearErrors,
    setValue: conciergeFormSetValue,
    setError: conciergeFormSetError,
  } = useForm({
    reValidateMode: "onSubmit",
    values: conciergeDetails,
    resolver: yupResolver(conciergeFormSchema),
  });
  const conciergeFormValidation: IValidationParms = {
    register: conciergeFormRegister,
    handleSubmit: conciergeFormHandleSubmit,
    errors: conciergeFormErrors,
    reset: conciergeFormReset,
    clearErrors: conciergeFormClearErrors,
    setValue: conciergeFormSetValue,
    setError: conciergeFormSetError
  };

  return (
    <>
      <main className="main-content">
        <div
          className="overlay"
          onClick={(e) => document.body.classList.toggle("sidebar-toggle")}
        ></div>

        <Box className="request-container-box">
          <div className="request-header">
            <div></div>
            <Button onClick={handleOnBackButtonClick} variant="outlined">
              <img src={ArrowBack} alt="arrow" />
              Back
            </Button>
          </div>

          <ConciergeForm
            handleOnBackButtonClick={handleOnBackButtonClick}
            validationParams={conciergeFormValidation}
            details={conciergeDetails}
            onChangeDetails={onChangeConciergeDetails}
          />
        </Box>
      </main>
    </>
  );
};

export default ConciergeRequest;
